import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { sharedReducers } from './reducers';
import * as effects from './effects';
import { LikeHttpService, FollowHttpService, AppSettingHttpService, CommentHttpService, ReminderHttpService } from '../services';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('sharedFeature', sharedReducers),
        EffectsModule.forFeature([
            effects.NotificationEffect,
            effects.AppSettingEffects,
            effects.LikeEffects,
            effects.FollowEffects,
            effects.CommentEffects,
            effects.ReminderEffects
        ])
    ],
    providers: [
        LikeHttpService,
        FollowHttpService,
        AppSettingHttpService,
        CommentHttpService,
        ReminderHttpService
    ]
})
export class SharedStoreModule { }
